module.exports = __webpack_public_path__ + "static/media/ExoBNNVARA-Black.4f50e630.woff";